import { atom } from 'jotai'

export const loginSignalAtom = atom<boolean>(false)

type CaptchaStatus = { passed: boolean; token: string | null; failed: boolean }

const initialCaptchaStatus: CaptchaStatus = { passed: false, token: null, failed: false }

export const captchaStatusAtom = atom<CaptchaStatus>(initialCaptchaStatus)

export const captchaAttemptAtom = atom(0)

export const resetCaptchaAtom = atom(null, (get, set) => {
  set(captchaStatusAtom, initialCaptchaStatus)
  set(captchaAttemptAtom, get(captchaAttemptAtom) + 1)
})
